export default __webpack_public_path__ + "static/media/18.87d2621a.jpg";